import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import Typing from '../Typing/Typing';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp';
import * as Utils from '../../services/utils';

function CmpsGetAppointment({onScroll, form, onShowInput}) {
  const [typing, setTyping] = useState(true);

  const pushDataLayer = () => {
    Utils.eventsDataLayer('chatbot_cta', 'Fissa appuntamento');
  }

  useEffect(() => {
    onShowInput(false);
    const timer = setTimeout(() => {
      setTyping(false);
      onScroll();
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="cmps-fissa-appuntamento">
      {typing && <Typing wait={1200} />}
      {!typing && (
        <>
          <div className="messages messages--receiver">
            <div className="message">
              <CmpsAnimation wait={300}>
                <span className="bubble">Hai terminato il processo, clicca sul<br /> bottone sotto per confermare la<br /> richiesta.</span>
              </CmpsAnimation>
              <CmpsAnimation wait={600} last={true}>
                <span className="bubble">Grazie e a presto!</span>
                <div className="info">
                  <span className="time"><Timestamp /></span>
                </div>
              </CmpsAnimation>
            </div>
          </div>
          <CmpsAnimation wait={900}>
            <Button htmlType="submit" onClick={pushDataLayer} className={['cmps_btn', 'cmps_btn__redirect']}>
            FISSA APPUNTAMENTO
            </Button>
          </CmpsAnimation>
        </>
      )}
    </section>
  );
  
} 

export default CmpsGetAppointment;